import { useEffect, useState } from 'react';
import { IoLogOutOutline, IoLogInOutline } from 'react-icons/io5';
import { FaRegEdit } from 'react-icons/fa';
import Accordion from '@mui/material/Accordion';
// import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { LinkIcon, Search } from 'lucide-react';
import { IoIosAdd, IoIosRemove } from 'react-icons/io';
import notes from '../../assets/notes.svg';
import maintance from '../../assets/maintence.svg';
import refill from '../../assets/refill.svg';
import cleaning from '../../assets/cleaning.svg';
import tour from '../../assets/tour.svg';
import emergency from '../../assets/emergency.svg';
import review from '../../assets/review.svg';
import appConfig from '../../config';
import cash from '../../assets/cash.svg';
import {
  getBnBData,
  getQuestions,
  getRefillMaintanceExtraCleaning,
  updateProcessBookings,
} from '../../helper/backend_helper';

const maintenanceItems = [
  { name: 'Emergency', icon: emergency },
  { name: 'Bad Review', icon: review },
  { name: 'Cash', icon: cash },
];

const DetailsPanel = ({ conversationDetail, setIsModalOpen }) => {
  const [expanded, setExpanded] = useState(null);
  const [BNBData, setBNBData] = useState(null);
  const [faq, setFaq] = useState([]);
  const [count, setCount] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedName, setSelectedName] = useState(conversationDetail?.user?.manual_status);
  const [copied, setCopied] = useState(false);

  console.log(selectedName);
  console.log(conversationDetail);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  const fetchData = async () => {
    try {
      const response = await getBnBData(conversationDetail?.user?.BnBShortName);
      const faqRes = await getQuestions(conversationDetail?.user?.BnBShortName, '');
      const counts = await getRefillMaintanceExtraCleaning(conversationDetail?.user?._id);
      setCount(counts.data);
      setFaq(faqRes?.data?.data);
      setBNBData(response?.data?.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (conversationDetail?.user?.BnBShortName) {
      fetchData();
    }
    setSelectedName(conversationDetail?.user?.manual_status);
  }, [conversationDetail?.user?.BnBShortName]);

  function getDayOfWeek(dateString) {
    // Convert the date string to a Date object
    const date = new Date(dateString);

    // Array of day names
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    // Return the day of the week
    return days[date.getDay()];
  }

  function getNightsBetweenDates(startDate, endDate) {
    // Convert the start and end dates to Date objects
    const start = new Date(startDate);
    const end = new Date(endDate);

    // Calculate the difference in milliseconds
    const differenceInMilliseconds = end - start;

    // Convert the difference to days
    const nights = differenceInMilliseconds / (1000 * 60 * 60 * 24);

    // Return the number of nights
    return nights > 0 ? nights : 0; // Return 0 if the end date is before the start date
  }

  const filteredFaq = faq?.filter(
    (item) =>
      item?.question?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item?.answer?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const AnswerDisplay = ({ answer }) => {
    const formattedAnswer = answer
      .replace(/(?:\r\n|\r|\n)/g, '<br />')
      .replace(
        /(https?:\/\/[^\s]+)/g,
        '<a href="$1" target="_blank" style="color: blue;" rel="noopener noreferrer">$1</a>'
      );

    return <div dangerouslySetInnerHTML={{ __html: formattedAnswer }} />;
  };
  if (!conversationDetail) {
    return <div className="bg-[#d9d9d9] p-4 h-[90vh] overflow-hidden max-lg:pb-1" />;
  }

  if (conversationDetail && !conversationDetail?.user) {
    return (
      <div className="bg-[#d9d9d9] p-4 h-[90vh] overflow-hidden max-lg:pb-1">
        {!conversationDetail?.isGroup && (
          <button
            onClick={() => setIsModalOpen(true)}
            className="flex items-center gap-1 text-[10px] bg-white text-center cursor-pointer px-3 flex-1 py-2 rounded-full mb-2"
          >
            <LinkIcon className="w-4 h-4" />
            <span>Connect Booking</span>
          </button>
        )}
        <iframe
          src="https://timelesspuglia.kross.travel/"
          title="Vesuview"
          className="w-full h-full"
          style={{
            border: 'none',
          }}
        />
      </div>
    );
  }

  const handleClick = async (itemName) => {
    try {
      const isSelected = selectedName === itemName; // Check if the item is already selected
      const newValue = isSelected ? 'none' : itemName; // Toggle value
      const data = { manual_status: newValue };
      await updateProcessBookings(conversationDetail?.user?._id, data); // Call the API
      setSelectedName((prev) => (prev === itemName ? 'none' : itemName)); // Toggle selection
    } catch (error) {
      console.error('Failed to update process booking:', error);
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(`${appConfig.SITE_URL}?bookingId=${conversationDetail?.user?._id}`);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000); // Hide after 2 sec
  };
  return (
    <div className=" bg-[#d9d9d9] p-1 h-[90vh] overflow-y-auto scrollbar-hide max-lg:pb-1 ">
      {/* Header */}
      <h3 className="font-bold text-black text-xl leading-6">{BNBData?.BnBLongName}</h3>
      <p className="text-sm text-gray-500 mt-1">
        {BNBData?.address}, {BNBData?.BnBShortName}
      </p>

      <div className="flex justify-between my-2 gap-3  items-center">
        <h1 className="text-[10px] bg-white text-center flex-1 px-1.5 py-1 rounded-full">Multiple Bookings</h1>
        <button
          title="Copy Link"
          onClick={copyToClipboard}
          className="text-[10px] bg-white text-center cursor-pointer px-1.5 flex-1 py-1 rounded-full"
        >
          Copy Guest Link
        </button>
      </div>
      {copied && (
        <div className="absolute top-10 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white px-3 py-1 rounded-md">
          Link copied!
        </div>
      )}
      <div className="flex justify-between my-2 gap-3  items-center">
        <div className=" bg-white flex-1 p-2 rounded-2xl">
          <div className="flex justify-between items-center">
            <div className="">
              <IoLogOutOutline size={26} />
            </div>
            <div>
              <FaRegEdit size={10} />
            </div>
          </div>
          <h1 className="text-[8px] mb-2">Checkin</h1>
          <h1 className="text-xs">{getDayOfWeek(conversationDetail?.user?.checkInDate)}</h1>
          <h1 className="text-xs">{conversationDetail?.user?.checkInDate}</h1>
          <h1 className="text-xs">{conversationDetail?.user?.checkInTime}</h1>
        </div>
        <div className=" bg-white flex-1 p-2 rounded-2xl">
          <div className="flex justify-between items-center ">
            <div className="">
              <IoLogInOutline size={26} />
            </div>
            <div>
              <FaRegEdit size={10} />
            </div>
          </div>
          <h1 className="text-[8px] mb-2">Checkout</h1>
          <h1 className="text-xs">{getDayOfWeek(conversationDetail?.user?.checkOutDate)}</h1>
          <h1 className="text-xs">{conversationDetail?.user?.checkOutDate}</h1>
          <h1 className="text-xs">{conversationDetail?.user?.checkOutTime}</h1>
        </div>
      </div>

      <div className="bg-white my-2 p-3 rounded-2xl">
        <div className="text-xs space-y-1">
          <div className="flex items-center">
            <h1 className="w-[50%]">Nights:</h1>
            <h1>
              {getNightsBetweenDates(conversationDetail?.user?.checkInDate, conversationDetail?.user?.checkOutDate)}
            </h1>
          </div>
          <div className="flex items-center">
            <h1 className="w-[50%]">Guests:</h1>
            <h1>{conversationDetail?.user?.noOfGuests}</h1>
          </div>
          <div className="flex items-center">
            <h1 className="w-[50%]">OTA:</h1>
            <h1>{conversationDetail?.user?.cod_channel}</h1>
          </div>
          <div className="flex items-center">
            <h1 className="w-[50%]">OTA ID:</h1>
            <h1>{conversationDetail?.user?.ota_id}</h1>
          </div>
          <div className="flex items-center">
            <h1 className="w-[50%]">Reservation ID:</h1>
            <h1>{conversationDetail?.user?.bookingId}</h1>
          </div>
          <div className="flex items-center">
            <h1 className="w-[50%]">Booking Value:</h1>
            <h1>{conversationDetail?.user?.charge_total_amount} €</h1>
          </div>
          <div className="flex items-center">
            <h1 className="w-[50%]">Property:</h1>
            <h1>
              {/* {BNBData?.status} */}
              {BNBData?.status.replace(/\b\w/g, (char) => char.toUpperCase())}
            </h1>
          </div>
        </div>
      </div>

      <div className="bg-white my-2 p-3 rounded-2xl">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <img className="w-5 h-5  object-cover" src={notes} alt="John Smith" />
            <h1 className="text-[10px]">Cleaners notes</h1>
          </div>
          <div>
            <FaRegEdit size={10} />
          </div>
        </div>
        <h1 className="text-xs mt-2">{conversationDetail?.user?.internal_note}</h1>
      </div>

      <div className="bg-white my-2 p-3 rounded-2xl">
        <form className="max-w-md mx-auto">
          {/* eslint-disable-next-line */}
          <label htmlFor="default-search" className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white">
            sdfsfs
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
              <svg
                className="w-3 h-3 text-gray-500 dark:text-gray-400"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 20"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                />
              </svg>
            </div>
            <input
              type="search"
              id="default-search"
              className="block outline-none text-xs w-full p-1 ps-8 border-black  text-gray-900 border  rounded-full bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-50 dark:border-gray-300 dark:placeholder-gray-400 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-[10px] mb-3"
              placeholder="Search FAQ here..."
              required
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)} // Update search term
            />
          </div>
        </form>

        <div className="h-48 overflow-auto scrollbar-hide">
          {filteredFaq?.map((item) => (
            <Accordion
              expanded={expanded === item?._id}
              onChange={handleChange(item?._id)}
              sx={{ backgroundColor: 'transparent', boxShadow: 'none' }}
            >
              <AccordionSummary
                expandIcon={
                  expanded === item?._id ? (
                    <IoIosRemove size={18} color="black" />
                  ) : (
                    <IoIosAdd size={18} color="black" />
                  )
                }
                sx={{ fontSize: '10px', padding: 0, color: 'black', margin: 0 }}
                className="h-6 -mt-2 -mb-1"
              >
                {item?.question}
              </AccordionSummary>
              <AccordionDetails sx={{ fontSize: '10px', padding: 0, margin: 0 }}>
                <div>
                  {item?.image && (
                    <img
                      src={`${appConfig.FILE_URL}${item?.image}`}
                      alt="img"
                      style={{ width: '100%', borderRadius: 10 }}
                    />
                  )}
                  <AnswerDisplay answer={item?.answer} />
                </div>
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      </div>

      <div className="bg-white my-2 p-3 rounded-2xl">
        <div className="flex justify-between items-center">
          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-2">
              <img className="w-5 h-5  object-cover" src={maintance} alt="John Smith" />
              {count.maintenance === 0 ? (
                <h1 className="text-[12px]">No maintenance</h1>
              ) : (
                <h1 className="text-[12px]">{count.maintenance} maintenance</h1>
              )}
            </div>
            <div className="flex items-center gap-2">
              <img className="w-5 h-5  object-cover" src={refill} alt="John Smith" />
              {count.refill === 0 ? (
                <h1 className="text-[12px]">No Refills</h1>
              ) : (
                <h1 className="text-[12px]">{count.refill} Refills</h1>
              )}
            </div>
            <div className="flex items-center gap-2">
              <img className="w-5 h-5  object-cover" src={cleaning} alt="John Smith" />
              {count.extraClenaing === 0 ? (
                <h1 className="text-[12px]">No Extra cleaning</h1>
              ) : (
                <h1 className="text-[12px]">{count.extraClenaing} Extra cleaning</h1>
              )}
            </div>
            <div className="flex items-center gap-2">
              <img className="w-5 h-5  object-cover" src={tour} alt="John Smith" />
              <h1 className="text-[12px]">No tours</h1>
            </div>
          </div>
          <div>
            <h1 className="bg-[#D9D9D9] rounded-full text-xs text-center px-2 py-1">Add extra</h1>
          </div>
        </div>
      </div>

      <div className="flex justify-between">
        {maintenanceItems.map((item, index) => (
          <div
            key={index}
            role="button" // Indicates the purpose of the element
            tabIndex="0" // Makes it focusable
            onClick={() => handleClick(item.name)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                setSelectedName((prev) => (prev === item.name ? 'none' : item.name));
              }
            }}
            className={`w-[32%] flex justify-around items-center bg-white rounded-2xl p-2 cursor-pointer ${
              selectedName === item.name ? 'border-2 border-black' : ''
            }`} // Add border if active
          >
            <div className="flex flex-col gap-1 justify-center items-center">
              <img className="w-5 h-auto" src={item.icon} alt={item.name} />
              <h1 className="font-sans font-normal text-Black text-[10px] text-center">{item.name}</h1>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-white my-2 rounded-full p-2">
        <h1 className="text-center text-[12px] ">Tasks Calendar</h1>
      </div>
    </div>
  );
};

export default DetailsPanel;
